<template>
  <w-button
    v-if="visible"
    class="noa-feegow-pms-btn"
    :label="buttonText"
    leading-icon="smart"
    variant="secondary"
    block
    @click="handleClick"
  />
</template>

<script setup lang="ts">
const props = defineProps({
  onClick: {
    type: Function,
    default: null,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  targetSelector: {
    type: String,
    default: undefined,
  },
  buttonText: {
    type: String,
    default: "Iniciar com Anotador de IA",
  },
});

const emit = defineEmits(["click"]);

function handleClick() {
  // Ensure we only open Noa, never close it
  const noaModal =
    document.querySelector("[data-noa-modal]") ||
    document.querySelector(".noa-modal") ||
    document.querySelector('[data-testid="noa-modal"]') ||
    document.querySelector(".ai-assistant-modal");

  const isNoaOpen =
    noaModal?.getAttribute("data-open") === "true" ||
    noaModal?.classList.contains("open") ||
    noaModal?.classList.contains("show") ||
    (noaModal as HTMLElement)?.style.display === "block" ||
    (noaModal as HTMLElement)?.style.visibility === "visible";

  // If Noa is already open, don't proceed with the click to avoid closing it
  if (isNoaOpen) {
    return;
  }

  // Click the target button if it exists
  if (props.targetSelector) {
    const targetBtn = document.querySelector(props.targetSelector) as HTMLElement;
    if (targetBtn) {
      if (typeof (targetBtn as any).onclick === "function") {
        (targetBtn as any).onclick.call(targetBtn);
      } else {
        targetBtn.dispatchEvent(new MouseEvent("click", { bubbles: true }));
      }
    }
  }

  // Call the onClick prop if provided
  if (props.onClick) {
    props.onClick();
  }

  emit("click");
}
</script>

<style scoped>
.noa-feegow-pms-btn {
  margin-top: 12px;
  width: 100%;
}
</style>
